/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Company/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Company({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/InsuredTreatmentItem/Payer/Company"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let txInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'tx',
path: 'insured.insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
  return (<React.Fragment
>
<div
  data-testid="Company.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Insurance Company:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 text={txInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData}
/>
</div>
{children}
</React.Fragment>)
}